import React from 'react';
import BtnPrimary from "../button/primary/BtnPrimary";
import BtnDefault from "../button/default/BtnDefault";

const BtnRow = ({submitAction, closeFormHandler}: { submitAction: () => void, closeFormHandler: () => void }) => {
    return (
        <div className={'btn-row'}>
            <BtnPrimary onClick={closeFormHandler} variant={'outline-primary'}
                        className={'text-primary'}>Annulla</BtnPrimary>
            <BtnPrimary onClick={submitAction}>Salva</BtnPrimary>
        </div>
    );
};

export default BtnRow;
